import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";

// Section (heading / subheading / leads / CTA)
export const GetCustomSynthesisCroSection = () => {
  return useQuery({
    queryKey: ["get-custom-synthesis-cro-section"],
    queryFn: () => client.customSynthesisCro.getSection(),
  });
};

export const UpdateCustomSynthesisCroSection = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (data) => client.customSynthesisCro.updateSection(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Section updated successfully!", "success");
        queryClient.invalidateQueries(["get-custom-synthesis-cro-section"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update section!", "error");
    },
  });
};

// Tags
export const GetCustomSynthesisCroTags = () => {
  return useQuery({
    queryKey: ["get-custom-synthesis-cro-tags"],
    queryFn: () => client.customSynthesisCro.getAllTags(),
  });
};

export const AddCustomSynthesisCroTag = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (data) => client.customSynthesisCro.addTag(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Tag added successfully!", "success");
        queryClient.invalidateQueries(["get-custom-synthesis-cro-tags"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to add tag!", "error");
    },
  });
};

export const UpdateCustomSynthesisCroTag = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: ({ id, data }) => client.customSynthesisCro.updateTag(id, data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Tag updated successfully!", "success");
        queryClient.invalidateQueries(["get-custom-synthesis-cro-tags"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update tag!", "error");
    },
  });
};

export const DeleteCustomSynthesisCroTag = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (id) => client.customSynthesisCro.deleteTag(id),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Tag deleted successfully!", "success");
        queryClient.invalidateQueries(["get-custom-synthesis-cro-tags"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to delete tag!", "error");
    },
  });
};

// FAQs
export const GetCustomSynthesisCroFaqs = () => {
  return useQuery({
    queryKey: ["get-custom-synthesis-cro-faqs"],
    queryFn: () => client.customSynthesisCro.getAllFaqs(),
  });
};

export const AddCustomSynthesisCroFaq = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (data) => client.customSynthesisCro.addFaq(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "FAQ added successfully!", "success");
        queryClient.invalidateQueries(["get-custom-synthesis-cro-faqs"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to add FAQ!", "error");
    },
  });
};

export const UpdateCustomSynthesisCroFaq = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: ({ id, data }) => client.customSynthesisCro.updateFaq(id, data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "FAQ updated successfully!", "success");
        queryClient.invalidateQueries(["get-custom-synthesis-cro-faqs"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update FAQ!", "error");
    },
  });
};

export const DeleteCustomSynthesisCroFaq = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (id) => client.customSynthesisCro.deleteFaq(id),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "FAQ deleted successfully!", "success");
        queryClient.invalidateQueries(["get-custom-synthesis-cro-faqs"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to delete FAQ!", "error");
    },
  });
};
